import { Invoice as ApiInvoice } from 'api/invoices';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action } from '../actions/invoices';

export type Invoice = ApiInvoice & {
  isFetching: boolean;
};
export type State = {
  byId: Record<
    string,
    Invoice & {
      isFetching: boolean;
    }
  >;
};
export default function invoices(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = {
    byId: {},
  },
  action: Action
) {
  switch (action.type) {
    case 'FETCH_INVOICE_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.invoiceId]: {
            ...state.byId[action.invoiceId],
            id: action.invoiceId,
            isFetching: true,
          },
        },
      };

    case 'FETCH_INVOICE_SUCCESS':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.invoice.id]: { ...action.invoice, isFetching: false },
        },
      };

    default:
      // this causes a flow error if there are any unhandled actions
      action as never; // eslint-disable-line no-unused-expressions

      return state;
  }
}
